import React from 'react';
import { Container, Paper, Toolbar, Box } from '@mui/material';
import { Routes, Route, Outlet, useParams } from 'react-router-dom';

import ClientsCompaniesList from './companies';
import ClientsList from './clients';
import ClientDetailWrapper from './client';
import PublicCompany from './company';

function CompanyDetailWrapper() {
  const { id } = useParams();
  return <PublicCompany id={parseInt(id!)} />;
}

/**
 * Clients module router component handling routes for companies and clients.
 * Supports creation and detail views for both entities.
 */
export default function ClientsIndex() {
  return (
    <>
      <Toolbar />
      <Container maxWidth="xl">
        <Paper>
          <Box p={2}>
            <Routes>
              <Route index element={<ClientsCompaniesList />} />
              <Route path="companies" element={<ClientsCompaniesList />} />
              <Route path="companies/new" element={<PublicCompany id={0} />} />
              <Route path="companies/:id/*" element={<CompanyDetailWrapper />} />
              <Route path="clients" element={<ClientsList />} />
              <Route path="clients/new" element={<ClientDetailWrapper />} />
              <Route path="clients/:id/*" element={<ClientDetailWrapper />} />
            </Routes>

            <Outlet />
          </Box>
        </Paper>
      </Container>
    </>
  );
}
